<template>
    <label class="headImageSelector block circle hiddenOverflow" :style="'width: ' + size + 'px; height: ' + size + 'px'">
        <img class="image fullSpace cover" :src="value ? value : ''"
             v-if="value" />
        <i class="icon plusIcon" :style="'width: ' + size + 'px; height: ' + size + 'px'"></i>
        <input type="file" class="hidden" name="file" @change="onChangeHeadImageFile"/>
    </label>
</template>

<script>
import fileApi from "@api/file";

import appHelper from '@/util/appHelper';

export default {
    name: "headImageSelector",
    props : {
        value : String,
        size : {
            type : Number,
            default : 48
        }
    },
    methods : {
        onChangeHeadImageFile(event) {
            let e = event.currentTarget;
            let file = e.files ? e.files[0] : null;
            if (!file)
            {
                return;
            }

            fileApi.uploadImage(file).then((res) => {

                let result = res.data;
                if (typeof(result) === 'string')
                {
                    result = JSON.parse(result);
                }
                this.value = result.data;
                this.$emit('input', this.value);
            }).catch((error) => {
                appHelper.generalAjaxError(error);
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.headImageSelector {
    //background: transparent;
    .plusIcon {
        background-image: url('data:image/png;base64,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');
    }
}
</style>
